<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="80vw">
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="addRow">
        New Rate Plan
      </v-btn>
      <v-card>
        <v-card-title class="primary">
          <span class="headline white--text">Edit RatePlan</span>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <v-form v-model="valid" lazyValidation>
              <v-container grid-list-md>
                <v-flex row wrap class="px-0">
                  <v-flex xs4 sm4 md4>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="ratePlainID"
                      rules="required|min_value:1"
                    >
                      <v-text-field
                        name="ratePlanID"
                        v-model="editedItem.ratePlanID"
                        label="UB Rateplan ID"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-layout row wrap class="pa-0">
                    <v-flex xs6>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="ratePlan"
                        rules="required"
                      >
                        <v-text-field
                          v-model="editedItem.ratePlanDescription"
                          label="Rate Plan"
                          name="ratePlan"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="usageType"
                        rules="required"
                      >
                        <v-select
                          data-vv-as="usageType"
                          name="usageType"
                          v-model="editedItem.usageType"
                          label="Usage Type"
                          :items="usageType"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="carrier"
                        rules="required"
                      >
                        <v-select
                          data-vv-as="carrier"
                          name="carrier"
                          v-model="editedItem.carrier"
                          label="Carrier"
                          :items="carriers"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="pa-0">
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="contractMonths"
                        rules="required"
                      >
                        <v-text-field
                          name="contractMonths"
                          v-model="editedItem.contractMonths"
                          label="Contract Months"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="monthlyRetail"
                        rules="required"
                      >
                        <v-text-field
                          name="monthlyRetail"
                          v-model="editedItem.monthlyRetail"
                          label="Monthly Retail"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="connectionFee"
                        rules="amount"
                      >
                        <v-text-field
                          name="connectionFee"
                          type="number"
                          v-model="editedItem.connectionFee"
                          label="Connection Fee"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="px-0">
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="dataAllowance"
                        rules="amount"
                      >
                        <v-text-field
                          name="dataAllowance"
                          type="number"
                          v-model="editedItem.dataAllowance"
                          label="Data Allowance (GB)"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="excessDataCharge"
                        rules="amount"
                      >
                        <v-text-field
                          name="excessDataCharge"
                          v-model="editedItem.excessDataCharge"
                          label="Excess Data Charge"
                          :error-messages="errors"
                          prefix="$"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-flex>
                    <v-flex>
                      <v-checkbox
                        name="monitorDataUsage"
                        v-model="editedItem.monitorDataUsage"
                        label="Monitor Data Usage"
                        hint="Same gate as daily usage monitoring."
                        persistent-hint
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-container grid-list-md text-xs-center class="pt-0">
                    <v-layout row wrap>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="pooledAllowance"
                          v-model="editedItem.pooledAllowance"
                          label="Pool Allowance"
                          :disabled="!editedItem.monitorDataUsage"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="emailNotification"
                          v-model="editedItem.emailNotification"
                          label="Email Notifications"
                          :disabled="!editedItem.monitorDataUsage"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="dealerSupplied"
                          v-model="editedItem.dealerSupplied"
                          label="Dealer Supplied"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="mixnMatch"
                          v-model="editedItem.mixnMatch"
                          label="Mix n Match"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="handset"
                          v-model="editedItem.handset"
                          label="Handset"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="additional"
                          v-model="editedItem.additionalServices"
                          label="Additional"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="residential"
                          v-model="editedItem.residential"
                          label="Residential"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="Rental"
                          v-model="editedItem.rental"
                          label="Hardware Rental"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0" v-if="allFlags.SOG8484">
                        <v-checkbox
                          name="RentalHardware"
                          v-model="editedItem.rentalHardware"
                          label="Vonex Rental Agreement"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="Qantas"
                          v-model="editedItem.qantas"
                          label="Qantas Plan"
                          hide-details
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="GrenkeFinance"
                          v-model="editedItem.grenkeFinance"
                          label="Grenke Finance"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="RestrictHardware"
                          v-model="editedItem.restrictHardwareOptions"
                          label="Restrict Hardware"
                          title="Set to false if you want this plan to allow all hardware options"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="Upgrade"
                          v-model="editedItem.upgrade"
                          label="Upgrade"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="Archived"
                          v-model="editedItem.archived"
                          label="Archived"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="IP Bundle"
                          v-model="editedItem.ipBundle"
                          label="IP Bundle"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="Disable 4G Back Up"
                          v-model="editedItem.disable4GBackUp"
                          label="Disable 4G Back Up"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0" v-if="allFlags.SOG9302">
                        <v-checkbox
                          name="4G Fibre Backup"
                          v-model="editedItem.fibre4GBackUp"
                          label="4G Fibre Backup"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="wholesale"
                          v-model="editedItem.isWholesale"
                          label="Wholesale"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md2 class="restrict-mix">
                        <v-toolbar dense>
                          <v-checkbox
                            name="RestrictedMix"
                            v-model="editedItem.cannotMixWithOthers"
                            label="Restricted Mix"
                            hide-details
                            append-outer-icon
                          ></v-checkbox>
                          <v-btn
                            icon
                            v-if="editedItem.cannotMixWithOthers"
                            @click="showRestricted = !showRestricted"
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <rateplan-autocomplete
                          v-if="showRestricted"
                          :item="editedItem"
                          @mixwith="updateMixWith"
                        ></rateplan-autocomplete>
                      </v-flex>
                      <v-flex xs12 md2 class="pa-0">
                        <v-checkbox
                          name="softphoneNoCharge "
                          v-model="editedItem.softphoneNoCharge"
                          label="Softphone No Charge($0)"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <ValidationProvider v-slot="{ errors }" name="description">
                    <v-text-field
                      v-model="editedItem.ratePlanDetails"
                      label="Description"
                      name="description"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12>
                  <ValidationProvider name="Image Path" v-slot="{ errors }">
                    <v-text-field
                      name="imagePath"
                      v-model="editedItem.imagePath"
                      label="Image Path"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete
                    :items="
                      resouceFiles.filter(x =>
                        x.category.toLowerCase().includes('product cis documents')
                      )
                    "
                    item-text="file"
                    item-value="id"
                    hint="Search for supporting resources"
                    label="Related Rate Sheet"
                    v-model="editedItem.resourceFileID"
                  ></v-autocomplete>
                </v-flex>
              </v-container>
            </v-form>
          </ValidationObserver>
          <message-alert :component="message"></message-alert>
        </v-card-text>
        <v-card-actions class="pb-4 pr-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="save">Save</v-btn>
          <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-layout row wrap>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-checkbox
            label="Archived"
            v-model="archived"
            :value="false"
            @change="getDataFromApi()"
          >
            Show Archived
          </v-checkbox>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :total-items="totalItems"
      :pagination.sync="pagination"
      :items="filteredRows"
      :headers="headers"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.ratePlanID }}</td>
        <td>{{ props.item.ratePlanDetails }}</td>
        <td>{{ props.item.ratePlanDescription }}</td>
        <td>{{ props.item.usageType }}</td>
        <td class="text-xs-center">{{ props.item.contractMonths }}</td>
        <td>
          <v-checkbox
            v-model="props.item.archived"
            :disabled="true"
          ></v-checkbox>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <message-alert :component="message"></message-alert>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import { mapDealerPortalMultiRowFields } from '@/store/modules/orders';
const { mapActions: mapDealerPortalActions } = createNamespacedHelpers(
  `orders/dealerPortal`
);
import {
  mapRatePlanFields,
  mapRatePlanMultiRowFields,
} from '../store/modules/orders';
import compact from 'lodash/compact';
import resourcesAutocomplete from './rateplan-resources.vue';

const {
  mapActions: mapRatePlanActions,
  mapMutations: mapRatePlanMutations,
} = createNamespacedHelpers(`orders/ratePlan`);
import { httpError } from '../models/httpError';
import { ratePlan } from '../models/ratePlan';
import rateplanAutocomplete from '@/components/dialogs/rateplanAutocomplete';
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(
  `orders/featureFlag`
);

export default {
  name: 'maintainRateplans',
  components: {
    rateplanAutocomplete,
  },
  data: () => ({
    showRestricted: false,
    archived: false,
    valid: true,
    dialog: false,
    editedItem: new ratePlan(),
    editedIndex: 0,
    SearchText: null,
    usageType: [],
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,
    resouceFiles: [],
    carriers: [
      { text: 'n/a', value: 'n/a' },
      { text: '2SG', value: '2SG' },
      { text: 'Optus', value: 'Optus' },
    ],
    headers: [
      {
        text: 'UB RatePlanID',
        align: 'left',
        sortable: false,
        value: 'ratePlanID',
      },
      {
        text: 'Rate Plan',
        align: 'left',
        sortable: true,
        value: 'ratePlanDetails',
      },
      {
        text: 'Description',
        align: 'left',
        sortable: true,
        value: 'ratePlanDescription',
      },
      {
        text: 'Usage Type',
        align: 'left',
        sortable: true,
        value: 'usageType',
      },
      {
        text: 'Contract Months',
        align: 'right',
        sortable: true,
        value: 'contractMonths',
      },

      {
        text: 'Archived',
        align: 'left',
        sortable: true,
        value: 'archived',
      },
      {
        text: '',
        align: 'right',
        sortable: false,
        value: '',
      },
    ],
  }),

  computed: {
    ...mapRatePlanFields(['message']),
    ...mapRatePlanMultiRowFields(['rows']),
    ...mapFeatureFlagGetters(['allFlags']),
    // ...mapDealerPortalMultiRowFields({ resouceFiles: "filteredRows" }),
    filteredRows: function() {
      let vm = this;
      return vm.rows.filter(this.isValid);
    },
  },

  methods: {
    ...mapDealerPortalActions(['getResourceFiles']),
    ...mapRatePlanActions([
      'getRatePlans',
      'saveRatePlans',
      'removeRatePlan',
      'saveRatePlan',
      'setMessage',
    ]),
    updateMixWith(val) {
      this.editedItem.mixWith = val;
    },
    addRow() {
      this.setMessage(new httpError());
      let item = new ratePlan();
      this.editedItem = item;
    },
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = vm.pagination;
        this.getRatePlans({ filter: null, archived: vm.archived }).then(
          data => {
            let items = data.data;
            const total = data.count;
            vm.usageType = compact(
              Array.from(new Set(vm.rows.map(a => a.usageType)))
            ).map(item => {
              return item !== 'nbnEnterprise'
                ? {
                    text: item,
                    value: item,
                  }
                : {
                    text: 'NBN Enterprise',
                    value: 'nbnEnterprise',
                  };
            });
            if (vm.allFlags.SOG3501)
              vm.usageType.push({
                text: 'Teams',
                value: 'Teams',
              });
            vm.loading = false;
            resolve({
              items,
              total,
            });
          }
        );
      });
    },

    editItem(item) {
      let vm = this;

      vm.$nextTick(() => {
        vm.setMessage(new httpError());
        vm.editedIndex = vm.rows.indexOf(item);
        vm.editedItem = vm.rows[vm.editedIndex];
        if (
          vm.editedItem.dataAllowance == null ||
          vm.editedItem.dataAllowance == undefined
        ) {
          let threshold = this.getNotificationThreshold();
          if (threshold != null) {
            this.editedItem.dataAllowance = parseInt(threshold);
          } else {
            this.editedItem.dataAllowance = null;
          }
        }
        this.syncUsageDependentFlags();
        vm.dialog = true;
      });
    },

    deleteItem(item) {
      this.setMessage(new httpError());
      const index = this.rows.indexOf(item);
      let answer = confirm('Are you sure you want to delete this item?');
      if (answer) {
        this.removeRatePlan(this.rows[index].id).then(data => {
          //this.items.splice(index, 1);
        });
      }
    },

    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = ['usageType', 'ratePlanDescription', 'ratePlanID'];

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = new ratePlan();
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let vm = this;
      vm.$refs.observer.validate().then(result => {
        if (result) {
          this.syncUsageDependentFlags();
          this.saveRatePlan(this.editedItem)
            .then(data => {
              this.close();
            })
            .catch(() => {});
        }
      });
    },

    syncUsageDependentFlags() {
      if (!this.editedItem || this.editedItem.monitorDataUsage) {
        return;
      }
      this.editedItem.pooledAllowance = false;
      this.editedItem.emailNotification = false;
    },

    getNotificationThreshold() {
      const regex = /(\d+)(gb|GB|Gb)/g;
      const matches = regex.exec(
        this.editedItem.ratePlanDescription.toString()
      );

      //if usage types of mobilevoice and HWBB
      if (matches && matches.length > 0) {
        let threshold = matches[0]
          .replace('Gb', '')
          .replace('gb', '')
          .replace('GB', '');
        return threshold;
      }
      return null;
    },
  },
  watch: {
    'editedItem.monitorDataUsage'() {
      this.syncUsageDependentFlags();
    },
  },
  mounted() {
    let vm = this;
    this.$nextTick(async () => {
      this.resouceFiles = await vm.getResourceFiles(true);
      await vm.getDataFromApi();
    });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.restrict-mix nav {
  background: none;
  border: 0;
  box-shadow: none;
}
.restrict-mix nav ::v-deep .v-toolbar__content{
  margin: 0 -4px !important;
  padding: 0 !important;
}
</style>
